export const businessModel = {
label: 'MODELO DE NEGOCIO',
title: 'Los Productos Primero. Las Relaciones Importan.',
subtitle: 'One More Global Inc. opera mediante un modelo de venta directa centrado en productos físicos de consumo y respaldado por distribuidores independientes.',

core_overview_p1: 'One More Global Inc. comercializa y distribuye productos de bienestar y cuidado personal mediante un modelo de venta directa. Los distribuidores independientes apoyan el conocimiento de los productos, las relaciones con clientes y el desarrollo de mercados de acuerdo con las políticas de la empresa y los requisitos aplicables.',
core_overview_p2: 'El modelo de negocio se construye en torno a productos físicos de consumo, distribución de productos, servicio al cliente y desarrollo de mercados a largo plazo.',

components_badge: 'Componentes del Modelo de Negocio',
components_title: 'Cómo Opera Nuestro Negocio',

component_1_title: 'Productos Físicos',
component_1_desc: 'El negocio se centra en la comercialización y distribución de productos físicos de bienestar y cuidado personal.',

component_2_title: 'Distribuidores Independientes',
component_2_desc: 'Los distribuidores independientes apoyan el conocimiento de los productos, las relaciones con clientes y el desarrollo de mercados.',

component_3_title: 'Relaciones con Clientes',
component_3_desc: 'Las relaciones a largo plazo con clientes se respaldan mediante información sobre productos, servicio y comunicación responsable.',

component_4_title: 'Crecimiento Responsable',
component_4_desc: 'El desarrollo de mercados se aborda mediante ejecución disciplinada, preparación operativa y relaciones comerciales a largo plazo.',
};
